var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mm-select',_vm._b({attrs:{"multiple":"","return-array":"","options":_vm.options,"value":_vm.selected},on:{"input":_vm.input}},'mm-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }